// Icons
import { Fingerprint, PersonAdd, Widgets } from "@mui/icons-material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import DrawIcon from "@mui/icons-material/Draw";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import PaidIcon from "@mui/icons-material/Paid";
import { ReactComponent as Sites } from "../GlobalAssets/svg/Sites.svg";
import { ReactComponent as Sitesfull } from "../GlobalAssets/svg/Sitesfill.svg";
import { ReactComponent as CreateSiteSvg } from "../GlobalAssets/svg/CreateSite.svg";
import { ReactComponent as CreateSiteFull } from "../GlobalAssets/svg/CreateSiteFull.svg";
// Local Imports
import Blueprint from "../Features/Admin/Pages/Blueprints/BlueprintOverview/Blueprints";
import OrganizationDashboard from "../Features/Admin/Pages/Organization/Pages/OrgDashboard/OrganizationDashboard";
import SiteDetails from "../Features/Admin/Pages/Sites/Subpages/SiteDetails/SiteDetails";
import DevTools from "../Features/Admin/Pages/Sites/Subpages/DevTools/DevTools";
import DomainHosted from "../Features/Admin/Pages/Sites/Subpages/DomainsHosted/DomainHosted";
import FileExplorer from "../Features/Admin/Pages/Sites/Subpages/FileExplorer/FileExplorer";
import Alerts from "../Features/Admin/Pages/Sites/Subpages/Alerts/Alerts";
import SiteAddons from "../Features/Admin/Pages/Sites/Subpages/SiteAddons/SiteAddons";
import CreateSite from "../Features/Admin/Pages/CreateSite/CreateSite/CreateSite";
import Payments from "../Features/Admin/Pages/Billing/Payments/Payments";
import SitesOverview from "../Features/Admin/Pages/Sites/SitesOverview/SitesOverview";
import TeamMembers from "../Features/Admin/Pages/Organization/Pages/TeamMembers/TeamMembers";
import OrganizationSettings from "../Features/Admin/Pages/Organization/Pages/OrganizationSettings/OrganizationSettings";
import Backups from "../Features/Admin/Pages/Sites/Subpages/Backups&Restore/Backups";
import OrganizationOverview from "../Features/Admin/Pages/Organization/Pages/OrganizationOverview/OrganizationOverview";
// import Signup from "../Features/Authentication/Pages/Signup/Signup";
// import Login from "../Features/Authentication/Pages/Login/Login";
// import ForgotPage from "../Features/Authentication/Pages/Forgot/Forgot";
// import ResetPage from "../Features/Authentication/Pages/Reset/Reset";
import Admin from "../Layouts/Admin/Admin";
// import AuthLayout from "../Layouts/Auth/Auth";
import PlanUsage from "../Features/Admin/Pages/Billing/Subpages/PlanUsage/PlanUsage";
import ModifyPlan from "../Features/Admin/Pages/Billing/Subpages/ModifyPlans/ModifyPlan";
import OrganizationOverviewAdmin from "../Layouts/Admin/OrganizationOverviewLayout/OrganizationOverviewAdmin";
import AddonPage from "../Features/Admin/Pages/Billing/Subpages/Addon/AddonPage";
import CreateOrgOption from "../Features/Admin/Pages/Organization/Components/CreateOrganizationOptions/CreateOrgOption";
import Profile from "../Layouts/Admin/AdminComponents/Navbar/Profile/Profile";
import ClientOrganizations from "../Features/Admin/Pages/Organization/Pages/ClientOrganizations/ClientOrganizations";
import Support from "../Features/Admin/Pages/Support/Support";
import Invoice from "../Features/Admin/Pages/Billing/Components/Invoice/Invoice";
import NewAuth from "../Layouts/Auth/NewAuth";
import NewLogin from "../Features/Authentication/Pages/Login/NewLogin";
import NewForgot from "../Features/Authentication/Pages/Forgot/NewForgot";
import NewReset from "../Features/Authentication/Pages/Reset/NewReset";
import NewSignup from "../Features/Authentication/Pages/Signup/NewSignup";
import SshPage from "../Features/Admin/Pages/Sites/Components/SSH/SshPage";
import ManageSites from "../Features/Admin/Pages/Sites/ManageSites/ManageSites";
import SiteMigration from "../Features/Admin/Pages/Sites/Subpages/SiteMigration/SiteMigration";
import NewPlanSignup from "../Features/Authentication/Pages/NewPlanSignup/NewPlanSignup";
import NewPlanSignupLayout from "../Layouts/NewPlanSignupLayout/NewPlanSignupLayout";
import StartPage from "../Features/Admin/AdminComponents/StartPage/StartPage";
// Import base route configuration
import { privateRoutesList as basePrivateRoutesList } from "./routeConfig";

const OrganizationOverviewRoutes = [
  {
    path: "/account/start",
    name: "Start",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: StartPage,
    layout: OrganizationOverviewAdmin,
  },
  {
    path: "/account/buy-plan",
    name: "Buy Plan",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: NewPlanSignup,
    layout: OrganizationOverviewAdmin,
  },
  {
    path: "/account/organizations-overview",
    name: "Organizations Overview",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: OrganizationOverview,
    layout: OrganizationOverviewAdmin,
  },
  {
    path: "/account/create-organization",
    name: "Organizations Overview",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: CreateOrgOption,
    layout: OrganizationOverviewAdmin,
  },
  {
    path: "/account/profile",
    name: "Profile",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: Profile,
    layout: OrganizationOverviewAdmin,
  },
  {
    path: "/account/:orgId/:siteId/ssh",
    name: "SSH",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: SshPage,
    layout: OrganizationOverviewAdmin,
  },
];

const OrganizationDashboardRoutesList = [
  {
    path: "/account/:orgId/dashboard",
    name: "Dashboard",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: OrganizationDashboard,
    layout: Admin,
  },
  {
    path: "/account/:orgId/support",
    name: "Support",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: Support,
    layout: Admin,
  },
  {
    path: "/account/:orgId/team-members",
    name: "Team Members",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: TeamMembers,
    layout: Admin,
  },
  {
    path: "/account/:orgId/manage-sites",
    name: "Manage Sites",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: ManageSites,
    layout: Admin,
  },
  {
    path: "/account/:orgId/client-organizations",
    name: "Client Organizations",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: ClientOrganizations,
    layout: Admin,
  },
  {
    path: "/account/:orgId/settings",
    name: "Dashboard settings",
    icon: DashboardIcon,
    outlinedIcon: DashboardOutlinedIcon,
    component: OrganizationSettings,
    layout: Admin,
  },
  {
    path: "/account/:orgId/create",
    name: "Create Site",
    icon: CreateSiteFull,
    outlinedIcon: CreateSiteSvg,
    component: CreateSite,
    layout: Admin,
  },
  {
    path: "/account/:orgId/sites-overview",
    name: "Sites",
    icon: Sitesfull,
    outlinedIcon: Sites,
    component: SitesOverview,
    layout: Admin,
  },
  {
    path: "/account/:orgId/:siteId/site-details",
    name: "Site Details",
    icon: Sitesfull,
    outlinedIcon: Sites,
    component: SiteDetails,
    layout: Admin,
  },
  {
    path: "/account/:orgId/:siteId/domains-hosted",
    name: "Domain Hosted",
    icon: Sitesfull,
    outlinedIcon: Sites,
    component: DomainHosted,
    layout: Admin,
  },
  {
    path: "/account/:orgId/:siteId/backups-restores",
    name: "Backups & Restore",
    icon: Sitesfull,
    outlinedIcon: Sites,
    component: Backups,
    layout: Admin,
  },
  {
    path: "/account/:orgId/:siteId/site-addons",
    name: "Add-ons",
    icon: Sitesfull,
    outlinedIcon: Sites,
    component: SiteAddons,
    layout: Admin,
  },
  {
    path: "/account/:orgId/:siteId/dev-tools",
    name: "Dev Tools",
    icon: Sitesfull,
    outlinedIcon: Sites,
    component: DevTools,
    layout: Admin,
  },
  {
    path: "/account/:orgId/:siteId/file-explorer",
    name: "File Explorer",
    icon: Sitesfull,
    outlinedIcon: Sites,
    component: FileExplorer,
    layout: Admin,
  },
  {
    path: "/account/:orgId/:siteId/alerts",
    name: "Alerts",
    icon: Sitesfull,
    outlinedIcon: Sites,
    component: Alerts,
    layout: Admin,
  },
  {
    path: "/account/:orgId/:siteId/site-migration",
    name: "Site Migration",
    icon: Sitesfull,
    outlinedIcon: Sites,
    component: SiteMigration,
    layout: Admin,
  },
  {
    path: "/account/:orgId/blueprints",
    name: "Blueprint",
    icon: DrawIcon,
    outlinedIcon: DrawOutlinedIcon,
    component: Blueprint,
    layout: Admin,
  },
  {
    path: "/account/:orgId/billing-overview",
    name: "Billing Overview",
    icon: PaidIcon,
    outlinedIcon: PaidOutlinedIcon,
    component: Payments,
    layout: Admin,
  },
  {
    path: "/account/:orgId/add-on",
    name: "Add-ons",
    icon: PaidIcon,
    outlinedIcon: PaidOutlinedIcon,
    component: AddonPage,
    layout: Admin,
  },
  {
    path: "/account/:orgId/plan-usage",
    name: "Plan Usage",
    icon: PaidIcon,
    outlinedIcon: PaidOutlinedIcon,
    component: PlanUsage,
    layout: Admin,
  },
  {
    path: "/account/:orgId/modify-plan",
    name: "Modify Plan",
    icon: PaidIcon,
    outlinedIcon: PaidOutlinedIcon,
    component: ModifyPlan,
    layout: Admin,
  },
  {
    path: "/account/:orgId/invoice",
    name: "Invoice",
    component: Invoice,
    layout: Admin,
  },
];

const publicRoutesList = [
  {
    path: "/new-signup",
    name: "New Signup",
    icon: PersonAdd,
    component: NewPlanSignup,
    layout: NewPlanSignupLayout,
  },
  {
    path: "/register",
    name: "Register",
    icon: PersonAdd,
    component: NewSignup,
    layout: NewAuth,
  },
  {
    path: "/login",
    name: "Login",
    icon: Fingerprint,
    component: NewLogin,
    layout: NewAuth,
  },
  {
    path: "/forgot",
    name: "forgot",
    icon: Widgets,
    component: NewForgot,
    layout: NewAuth,
    redirect: true,
  },
  {
    path: "/verify",
    name: "verify",
    icon: Widgets,
    component: NewReset,
    layout: NewAuth,
    redirect: true,
  },
];

// Populate the routes with actual components
const privateRoutesList = basePrivateRoutesList.map((route) => {
  const populatedRoute = { ...route };

  // Populate main components
  switch (route.subPath) {
    case "dashboard":
      populatedRoute.component = OrganizationDashboard;
      // Populate sub-routes
      if (populatedRoute.subRoutes) {
        populatedRoute.subRoutes = populatedRoute.subRoutes.map((subRoute) => ({
          ...subRoute,
          component:
            subRoute.path === "team-members"
              ? TeamMembers
              : subRoute.path === "client-organizations"
              ? ClientOrganizations
              : subRoute.path === "settings"
              ? OrganizationSettings
              : null,
        }));
      }
      break;
    case "create":
      populatedRoute.component = CreateSite;
      break;
    case "sites-overview":
      populatedRoute.component = SitesOverview;
      // Populate sub-routes
      if (populatedRoute.subRoutes) {
        populatedRoute.subRoutes = populatedRoute.subRoutes.map((subRoute) => ({
          ...subRoute,
          component:
            subRoute.path === ":siteId/site-details"
              ? SiteDetails
              : subRoute.path === ":siteId/domains-hosted"
              ? DomainHosted
              : subRoute.path === ":siteId/backups-restores"
              ? Backups
              : subRoute.path === ":siteId/dev-tools"
              ? DevTools
              : subRoute.path === ":siteId/file-explorer"
              ? FileExplorer
              : subRoute.path === ":siteId/alerts"
              ? Alerts
              : subRoute.path === ":siteId/site-addons"
              ? SiteAddons
              : subRoute.path === ":siteId/site-migration"
              ? SiteMigration
              : null,
        }));
      }
      break;
    case "blueprints":
      populatedRoute.component = Blueprint;
      break;
    case "billing-overview":
      populatedRoute.component = Payments;
      // Populate sub-routes
      if (populatedRoute.subRoutes) {
        populatedRoute.subRoutes = populatedRoute.subRoutes.map((subRoute) => ({
          ...subRoute,
          component:
            subRoute.path === "plan-usage"
              ? PlanUsage
              : subRoute.path === "modify-plan"
              ? ModifyPlan
              : subRoute.path === "add-on"
              ? AddonPage
              : null,
        }));
      }
      break;
  }

  return populatedRoute;
});

export {
  OrganizationDashboardRoutesList,
  publicRoutesList,
  privateRoutesList,
  OrganizationOverviewRoutes,
};
